import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LogOut, ArrowLeft, ChevronDown } from 'lucide-react';
import { useAuth } from '../../../context/AuthContext';

const LOGO = 'https://static.prod-images.emergentagent.com/jobs/9de54d98-d977-4d52-98c6-87def6f7dbb6/images/e4af12b1fd03afcac81e7bb84146d1c3be55c42647b453eb7f18eeb53e861031.png';

export const SECTIONS = [
  { key: 'dashboard', label: 'Dashboard', items: [{ to: '/brand/tracker', label: 'Overview' }, { to: '/brand/tracker/settings', label: 'Settings' }] },
  { key: 'competitors', label: 'Competitors', items: [{ to: '/brand/competitors', label: 'Overview' }, { to: '/brand/competitors/tracker', label: 'Tracker' }] },
];

const sectionFor = (path) => (path.startsWith('/brand/competitors') ? 'competitors' : 'dashboard');
const itemActive = (to, path) => {
  if (to === '/brand/competitors') return path === to || (path.startsWith('/brand/competitors/') && !path.startsWith('/brand/competitors/tracker'));
  return path === to;
};

export const BrandTopNav = ({ brandName }) => {
  const { pathname } = useLocation();
  const { logout } = useAuth();
  const [hover, setHover] = useState(null);
  const shown = SECTIONS.find((s) => s.key === (hover || sectionFor(pathname)));

  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-xl border-b border-black/[0.06]" onMouseLeave={() => setHover(null)} data-testid="brand-top-nav">
      <div className="max-w-[1400px] mx-auto px-8 h-16 flex items-center justify-between">
        <Link to="/brand/tracker" className="flex items-center gap-2" data-testid="brand-nav-logo">
          <img src={LOGO} alt="Vyvre" className="w-10 h-10 object-contain" />
          <span className="font-display text-2xl leading-none tracking-tight"><span className="text-[#0F0F0F]">Vy</span><span className="italic text-[#FF451A]">vre</span></span>
        </Link>
        <nav className="flex items-center gap-1">
          {SECTIONS.map((s) => {
            const active = (hover || sectionFor(pathname)) === s.key;
            return (
              <Link
                key={s.key}
                to={s.items[0].to}
                onMouseEnter={() => setHover(s.key)}
                className={`relative px-5 py-2 rounded-full text-sm font-semibold inline-flex items-center gap-1 transition-colors ${active ? 'text-[#FF451A] bg-[#FF451A]/[0.08]' : 'text-[#3F3F46] hover:text-[#0F0F0F] hover:bg-black/[0.03]'}`}
                data-testid={`brand-nav-section-${s.key}`}
              >
                {s.label} <ChevronDown size={13} className={`transition-transform ${hover === s.key ? 'rotate-180' : ''}`} />
              </Link>
            );
          })}
        </nav>
        <div className="flex items-center gap-4">
          <Link to="/brand/dashboard" className="text-xs text-[#6B6B6B] hover:text-[#FF451A] inline-flex items-center gap-1 transition-colors" data-testid="brand-nav-back-portal"><ArrowLeft size={12} /> Brand Portal</Link>
          <span className="text-sm font-semibold text-[#0F0F0F]" data-testid="brand-nav-brand-name">{brandName}</span>
          <button onClick={logout} title="Log out" className="rounded-full p-2 text-[#6B6B6B] hover:text-[#FF451A] hover:bg-[#FF451A]/[0.08] transition-colors" data-testid="brand-nav-logout"><LogOut size={16} /></button>
        </div>
      </div>
      <div className="border-t border-black/[0.04] bg-[#FFFAF7]" data-testid="brand-nav-subbar">
        <div className="max-w-[1400px] mx-auto px-8 h-11 flex items-center justify-center gap-1">
          {shown.items.map((it) => (
            <Link
              key={it.to}
              to={it.to}
              className={`px-4 py-1.5 text-[13px] font-medium rounded-full transition-colors ${itemActive(it.to, pathname) ? 'bg-[#FF451A] text-white shadow-[0_4px_14px_rgba(255,69,26,0.3)]' : 'text-[#52525B] hover:text-[#FF451A]'}`}
              data-testid={`brand-nav-item-${shown.key}-${it.label.toLowerCase()}`}
            >
              {it.label}
            </Link>
          ))}
        </div>
      </div>
    </header>
  );
};
